export default "__VITE_ASSET__Djr3MUke__"